import {memo, useCallback} from 'react'
import {useLocation} from 'react-router-dom'

import {useSetQueryParams} from '../../../../../../hooks/routes'
import RowGroup from '../../../../../common/Grid/RowGroup'
import Icon from '../../../../../common/Icon/Icon'
import {OrderByField, OrderDirection} from '../../../../../packages/Tests/Tests.types'
import {defaultFilterTemplate, getFilterQueryParams} from '../../BuildTestsTab.utils'

import styles from './TestScopesViewHeader.css'

type Props = {
  withCountersColumns?: boolean
}

function TestScopesViewHeader({withCountersColumns}: Props) {
  const location = useLocation()
  const setQueryParams = useSetQueryParams()
  const {orderBy, order} = getFilterQueryParams(location, {
    ...defaultFilterTemplate,
    orderBy: OrderByField.DURATION,
  })
  const onChangeSorting = useCallback(
    (newOrderBy: OrderByField, priorityOrder: OrderDirection = OrderDirection.ASC) => {
      let newOrder = priorityOrder

      if (newOrderBy === orderBy) {
        if (order === OrderDirection.ASC) {
          newOrder = OrderDirection.DESC
        } else {
          newOrder = OrderDirection.ASC
        }
      }

      setQueryParams({
        orderBy: newOrderBy,
        order: newOrder,
      })
    },
    [orderBy, order, setQueryParams],
  )
  const renderColumn = useCallback(
    (type: OrderByField, name: string, withSorting: boolean, priorityOrder?: OrderDirection) => (
      <div
        className={
          type !== OrderByField.STATUS &&
          type !== OrderByField.RUN_ORDER &&
          type !== OrderByField.NEW_FAILURE &&
          type !== OrderByField.BUILD_START_DATE
            ? styles[`${type}Column`]
            : undefined
        }
        key={type}
      >
        {withSorting ? (
          <button
            type="button"
            className={styles.columnTitle}
            onClick={() => onChangeSorting(type, priorityOrder)}
          >
            {orderBy === type && (
              <Icon name={order === OrderDirection.ASC ? 'chevron-up' : 'chevron-down'} />
            )}
            {name}
          </button>
        ) : (
          <span>{name}</span>
        )}
      </div>
    ),
    [orderBy, order, onChangeSorting],
  )
  return (
    <RowGroup>
      <div className={styles.tableHeader}>
        {[
          renderColumn(OrderByField.NAME, 'Name', true),
          renderColumn(OrderByField.DURATION, 'Duration', true, OrderDirection.DESC),
          renderColumn(OrderByField.COUNT, 'Tests', true, OrderDirection.DESC),
          withCountersColumns ? renderColumn(OrderByField.SUCCESS, 'Success', false) : null,
          withCountersColumns ? renderColumn(OrderByField.FAILURE, 'Failure', false) : null,
          withCountersColumns ? renderColumn(OrderByField.MUTED, 'Muted', false) : null,
          withCountersColumns ? renderColumn(OrderByField.IGNORED, 'Ignored', false) : null,
        ].filter(Boolean)}
      </div>
    </RowGroup>
  )
}

export default memo<Props>(TestScopesViewHeader)
